const data = [
    {
        id : 1,
        heading : "Who We Are",
        body : "Vann Holdings is a freight \
        brokerage and supply chain solutions\
         provider that helps you manage your \
         logistics operations more efficiently.",
    },

    {
        id : 2,
        heading : "Our Vision",
        body : "To become a leader in the logistics industry, \
        committed to creating innovative solutions that will help\
         provide our customers with the best possible service.",
    },
    {
        id : 3,
        heading : "Our Mission",
        body : "At Vann Holdings, our mission is to provide the highest\
         level of freight brokerage services to our customers, providing\
          safe, secure, and cost-effective solution for all of our clients’\
           shipping needs."
    }

] 

export default data;